export default __webpack_public_path__ + "static/media/coracaoMenu.aaf35061.svg";